<template>
  <SogCard>
    <SogCardTitle>Einkauf/Verkauf</SogCardTitle>
    <SogCardContent v-show="_progressInfo">
      <SogProgressInfoComponent
        :progress-info="_progressInfo"
        :show-caption="false"
      />
    </SogCardContent>
    <SogCardContent v-show="!_progressInfo">
      <SogForm>
        <SogFormField>
          <SogDatePicker
            v-model="_from"
            placeholder="Von"
          />
        </SogFormField>
        <SogFormField>
          <SogDatePicker
            v-model="_till"
            placeholder="Bis"
            :min="_from"
          />
        </SogFormField>
      </SogForm>
    </SogCardContent>
    <SogCardActions>
      <SogCardActionButton
        mdi-icon="mdi-file-excel"
        @click="onImport"
      >
        Exportieren
      </SogCardActionButton>
    </SogCardActions>
  </SogCard>
</template>

<script setup lang="ts">

import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import {useSpinner} from "@/shared/composables/SogSpinner";
import apiReport from "@/modules/Report/api";
import apiFile from "@/shared/services/apiFile";
import {ref, watch} from "vue";
import SogProgressInfoComponent from "@/shared/ui/SogProgressInfoComponent.vue";
import {useProgressInfo} from "@/shared/composables/SogProgressInfo";
import SogForm from "@/shared/ui/SogForm.vue";
import SogFormField from "@/shared/ui/SogFormField.vue";
import SogDatePicker from "@/shared/ui/SogDatePicker.vue";
import {addMonths, firstDayOfMonths} from "@/shared/utils/DateUtils";


const _spinner = useSpinner()

const _progressId = ref<string|undefined>(undefined);

const {progressInfo:_progressInfo} = useProgressInfo(_progressId,false)
const _from = ref<Date|undefined>(firstDayOfMonths(addMonths(new Date(),-1)))
const _till = ref<Date|undefined>(new Date())

watch((_progressInfo),async () => {
    if (_progressInfo.value?.successful && _progressInfo.value?.resultId) {
      await apiFile.downloadFile(_progressInfo.value.resultId)
      _progressInfo.value = undefined
    }
})


async function onImport() {
  if(!_from.value || !_till.value){
    return
  }
  _spinner.show()
  _progressId.value = await apiReport.purchaseSale(_from.value,_till.value);
  _spinner.hide()
}


</script>

<style scoped>

</style>
